import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { API } from '../constants';
import { processRequestForAccountingArea } from './network/managedRequestForAccountingArea';
import { PbDispatch } from './index';
import { PbRequest } from './pbRequest';

export interface RequestOAuthLandingPageForLocation {
    location_id: number;
    email: string;
}

export enum LocationApaleoLinkStatus {
    INITIAL = 'INITIAL',
    CODE_GENERATED = 'CODE_GENERATED',
    ACCESS_GRANTED = 'ACCESS_GRANTED',
    COMPLETED = 'COMPLETED',
}

export interface PropertyLinkInfoDto {
    code?: string;
    url?: string;
    status?: LocationApaleoLinkStatus;
}

interface OAuthStore {
    propertyLinkInfoData: PropertyLinkInfoDto | undefined;
    sendEmailForPropertyLinkData: PropertyLinkInfoDto | undefined;
}

const initialState: OAuthStore = {
    sendEmailForPropertyLinkData: undefined,
    propertyLinkInfoData: undefined,
};

export const propertyLink = createSlice({
    name: 'propertyLink',
    initialState,
    reducers: {
        setRequestOAuthLandingPageRequestStatus(
            state: OAuthStore,
            action: PayloadAction<PropertyLinkInfoDto>
        ) {
            state.sendEmailForPropertyLinkData = action.payload;
        },
        setPropertyLinkInfo(
            state: OAuthStore,
            action: PayloadAction<PropertyLinkInfoDto>
        ) {
            state.propertyLinkInfoData = action.payload;
        },
    },
});

export function RequestPropertyLinkInfoForLocationId(locationId: number) {
    return async (dispatch: PbDispatch) => {
        const request = { method: 'GET' };
        const response =
            await processRequestForAccountingArea<PropertyLinkInfoDto>(
                dispatch,
                `${API}/oauth/property_link/locations/${locationId}`,
                request,
                PbRequest.GET_PROPERY_LINK_INFO_REQUEST
            );
        dispatch(propertyLink.actions.setPropertyLinkInfo(response));
    };
}

export function RequestSendEmailForPropertyLink(
    requestOAuthLandingPageForLocation: RequestOAuthLandingPageForLocation
) {
    return async (dispatch: PbDispatch) => {
        const request = {
            method: 'POST',
            body: JSON.stringify(requestOAuthLandingPageForLocation),
        };
        const response =
            await processRequestForAccountingArea<PropertyLinkInfoDto>(
                dispatch,
                `${API}/oauth/property_link`,
                request,
                PbRequest.SEND_EMAIL_FOR_PROPERTY_LINK_REQUEST
            );
        dispatch(
            propertyLink.actions.setRequestOAuthLandingPageRequestStatus(
                response
            )
        );
    };
}

export default propertyLink.reducer;
